function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip-path"
}, React.createElement("path", {
  id: "Path_90",
  "data-name": "Path 90",
  d: "M0,0H15V15H0Z",
  fill: "none",
  clipRule: "evenodd"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_2809",
  "data-name": "Group 2809",
  transform: "translate(-534 -343)"
}, React.createElement("g", {
  id: "Rectangle_1096",
  "data-name": "Rectangle 1096",
  transform: "translate(534 343)",
  fill: "#fff",
  stroke: "#597ef7",
  strokeWidth: 1
}, React.createElement("rect", {
  width: 19,
  height: 19,
  rx: 2,
  stroke: "none"
}), React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 18,
  height: 18,
  rx: 1.5,
  fill: "none"
})), React.createElement("g", {
  id: "Group_2115",
  "data-name": "Group 2115",
  transform: "translate(536 369)"
}, React.createElement("g", {
  id: "Group_280",
  "data-name": "Group 280",
  transform: "translate(0 -24)"
}, React.createElement("g", {
  id: "Group_277",
  "data-name": "Group 277",
  clipPath: "url(#clip-path)"
}, React.createElement("g", {
  id: "Group_276",
  "data-name": "Group 276"
}, React.createElement("path", {
  id: "Path_89",
  "data-name": "Path 89",
  d: "M0,0H15V15H0Z",
  fill: "none",
  stroke: "rgba(112,112,112,0.01)",
  strokeWidth: 0
}))), React.createElement("g", {
  id: "Group_279",
  "data-name": "Group 279",
  clipPath: "url(#clip-path)"
}, React.createElement("g", {
  id: "Group_278",
  "data-name": "Group 278",
  transform: "translate(3.125 3.125)"
}, React.createElement("path", {
  id: "Path_91",
  "data-name": "Path 91",
  d: "M13.75,5.881,12.869,5,9.375,8.494,5.881,5,5,5.881,8.494,9.375,5,12.869l.881.881,3.494-3.494,3.494,3.494.881-.881L10.256,9.375Z",
  transform: "translate(-5 -5)",
  fill: "#597ef7"
}))))));

var SvgIconremove = function SvgIconremove(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconremove, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Iconremove.dbda0131.svg";
export { ForwardRef as ReactComponent };